import React, { useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import ModalFooter from "./UserPageForms/ModalFooter";
import Checkbox from "./Checkbox";

const QuickAddUserModal = (props) => {
  const [newUser, setNewUser] = useState({
    fullName: "",
    domainName: "",
    companyName: "",
    licenseBundleId: "",
    asanaCheck: false,
    cityViewCheck: false,
    turnOnCityView: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [props.show]);

  const updateUser = (nameOfField, value) => {
    setNewUser({ ...newUser, [nameOfField]: value });
  };

  const updateBusinessUnit = (value) => {
    let companyName = props.businessUnits.find((x) => x.businessUnitName === value).bcCompanyName;
    setNewUser({ ...newUser, companyName: companyName });
  };

  return (
    <Modal show={props.show} onHide={props.onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Quick Add User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
            <Form.Group className="mb-3 w-50" controlId="userFullName">
              <Form.Label>
                <b>Full Name</b>
              </Form.Label>
              <Form.Control
                as="input"
                placeholder="Enter User Full Name"
                custom
                onChange={(value) => updateUser("fullName", value.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="mb-3 w-50" controlId="userDomainName">
              <Form.Label>
                <b>Domain Name</b>
              </Form.Label>
              <Form.Control
                as="input"
                placeholder="Enter User Domain Name"
                custom
                onChange={(value) => updateUser("domainName", value.target.value)}
              ></Form.Control>
            </Form.Group>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
            <Form.Group className="mb-3 w-50" controlId="userBusinessUnit">
              <Form.Label>
                <b>Company</b>
              </Form.Label>
              <Form.Select
                placeholder="Enter User Business Unit"
                custom
                onChange={(value) => updateBusinessUnit(value.target.value)}
              >
                <option>Select User Business Unit</option>
                {props.businessUnits &&
                  props.businessUnits
                    .sort((x, y) => x.businessUnitName.toString().toLowerCase().localeCompare(y.businessUnitName))
                    .map((businessUnit) => {
                      return <option key={businessUnit.businessUnitGuid}>{businessUnit.businessUnitName}</option>;
                    })}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 w-50" controlId="userBundle">
              <Form.Label>
                <b>Bundle</b>
              </Form.Label>
              <Form.Select
                placeholder="Enter User Bundle"
                custom
                onChange={(value) => updateUser("licenseBundleName", value.target.value)}
              >
                <option>Select User Bundle</option>
                {props.bundles &&
                  props.bundles
                    .filter((x) => x.iTaaS == false)
                    .map((bundle) => {
                      return <option key={bundle.bundleId}>{bundle.bundleName}</option>;
                    })}
              </Form.Select>
            </Form.Group>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
            <Form.Group className="mb-3 w-50" controlId="userITaaSLevel">
              <Form.Label>
                <b>ITaaS Level</b>
              </Form.Label>
              <Form.Select
                placeholder="Enter ITaaS Level"
                custom
                onChange={(value) => updateUser("itaasLevel", value.target.value)}
              >
                <option>Select User ITaaS Level</option>
                <option>None</option>
                <option>Standard</option>
                <option>Premium</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 w-50" controlId="updateUserSelect">
              <Form.Label>
                <b>Asana Level</b>
              </Form.Label>
              <Form.Select custom onChange={(value) => updateUser("asanaPackageShortName", value.target.value)}>
                <option>Select User Asana Level</option>
                <option>None</option>
                <option>Employee</option>
                <option>Owner</option>
              </Form.Select>
            </Form.Group>
          </div>
          <Form.Group>
            {newUser.turnOnCityView && (
              <Checkbox
                checked={newUser.cityViewCheck}
                onChange={() => updateUser("cityViewCheck", !newUser.cityViewCheck)}
                label="City View Bundle?"
              />
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <ModalFooter
        mode="quickAdd"
        onSubmitClick={() => {
          setIsLoading(true);
          props.onAdd(newUser);
        }}
        submitLoading={isLoading}
        onHide={props.onHide}
      />
    </Modal>
  );
};

export default QuickAddUserModal;
